<template>
  <div class="top">
    <h1>AnyTeach 约课平台</h1>
    <h2>最具革命性的幼少儿英语启蒙</h2>
  </div>
</template>
<script>
export default {
  name: "Top",
}
</script>
<style lang="scss" scoped>
@import "./style.scss";

.top {
  padding: 70px 0 20px 0;
}

@media only screen and (max-height: 600px) {
  .top {
    padding: 50px 0 5px 0;
  }
}
</style>
